module.exports = __webpack_public_path__ + "img/arrows-minimize.10fe6bed.svg";